<template>
  <section>
    <div class="section section-header section-row div-5">
      <div>Lists</div>
      <div class="double-f">
        List Type
      </div>
      <div class="right-field">
        Projected <br>
        Allotment
      </div>
      <div class="right-field">
        Amount
      </div>
    </div>
    <div>
      <template
        v-for="(key, index) in listsKeys"
        :key="key"
      >
        <ListsRowForm
          :form-id="key"
          :initial-values="(lists && lists[index]) || {}"
          :disabled="loading"
          class="section section-row div-5 with-border"
          @blur="onListRowBlur(key)"
          @save="onRowSave(key)"
          @clear="onRowDelete(key)"
        />
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { useOfferSheetFormStore } from '@/stores/offer-sheet-form';
import { useFormsStore } from 'vuniform';
import ListsRowForm from './ListsRowForm.vue';
import type { UpsertListInput } from '@/generated/graphql';

interface Props {
  formIdPrefix: string;
}
defineProps<Props>();

const offerSheetStore = useOfferSheetStore();
const offerSheetFormStore = useOfferSheetFormStore();
const formsStore = useFormsStore();
const lists = computed(() => offerSheetStore.offerSheet?.lists);
const loading = computed(() => offerSheetStore.listsLoading);

const listsKeys = computed(() => offerSheetFormStore.listsFormIds);

const deleteRow = (formId: string) => {
  offerSheetFormStore.deleteListRow(formId);
};

const onListRowBlur = (key: string) => {
  onRowSave(key);
};

const onRowDelete = async (formId: string) => {
  const id = formsStore.fieldGetValue(formId, 'id');
  if (!id) {
    return;
  }

  await offerSheetStore.deleteList(id);

  deleteRow(formId);
};

const onRowSave = async (formId: string) => {
  if (loading.value || !formsStore.isFormDirty(formId)) {
    return;
  }

  const payload = formsStore.formGetValues<UpsertListInput>(formId);
  payload.offerSheetId = offerSheetStore.offerSheet.id;
  payload.projected = +payload.projected;
  payload.clientMutationId = formId;

  const list = await offerSheetStore.upsertList(payload);

  formsStore.SET_INITIAL_VALUES({
    values: { ...list },
    formId,
    clearDirty: true,
  });
};
</script>
